import { filterConditionAtom } from '@/features/analyze/atoms/filterCondition.atom';
import { ArticleSearchConditionInput } from '@/features/analyze/types';
import { format } from '@formkit/tempo';
import { useAtomValue } from 'jotai';

/**
 * 記事検索で使用するArticleSearchConditionInputを構築する共通hook
 */
export const useArticleSearchCondition = (): ArticleSearchConditionInput => {
  const { publishedStartAt, publishedEndAt, ...rest } =
    useAtomValue(filterConditionAtom);

  return {
    ...rest,
    publishedStartDate:
      publishedStartAt && format(publishedStartAt, 'YYYY-MM-DD'),
    publishedEndDate: publishedEndAt && format(publishedEndAt, 'YYYY-MM-DD'),
  };
};
